import $axios from 'axios'
import { Message } from 'element-ui'
import Router from '@/router'
import { getCookies,setCookies } from "@/utils/utils";

/*
 * @发送网络请求  sendRequest()
 * @param {string}   url  请求的地址
 * @param {object}   data:object    要发送的参数
 *                   method:string  请求方式 GET或POST
 *                   param:array    扩展参数
 * @return {object}  res  后台返回数据
 */

const sendRequest = (  url,{ data = {}, method = 'POST', isWarning = true, ...param } = {} ) => {
  return new Promise((resolve, reject) => {

    let instance = $axios.create({
      baseURL: url,
      method: method,
      timeout: 10000, // 超时时间
      withCredentials: false, //表示跨域请求时是否需要使用凭证
      headers: {
        // 'Content-Type':'application/x-www-form-urlencoded',
         Authorization: getCookies("token") || ""
        },
    })

    // 添加请求拦截器
    instance.interceptors.request.use(
      config => {

        // 生成签名
        let wuBaNfJson = {
          params: data,
          timestamp: new Date().getTime(),
          // sign: sign(data)
        }

        // config.method === 'post'
        //   ? (config.data = wuBaNfJson)
        //   : (config.params = wuBaNfJson)

        if(config.method === 'post' || config.method === 'delete'){
          config.data = data
        }else{
          config.params = data
        }
        return config

      },

      error => {
        return Promise.reject(error)
      }
    )

    // 添加响应拦截器
    instance.interceptors.response.use(
      response => {
        if (response.data.code !== 200) {
        }
        return response.data;
      },
      
      error => {
        return Promise.reject(error)
      }
    )

    instance()
      .then(response => {

        response && resolve(response)

      })
      .catch(error => {
        console.log('请求异常信息：' + error,error.response);
        reject(error)
      })
  })
}

export default sendRequest



// WEBPACK FOOTER //
// ./src/fetch/fetch.js